import {
  MagicRulesFileId,
  OrgGuideFileId,
  OrgGuideFileVersionId,
  OrgId,
  UserId,
  guardNever,
} from "@hex/common";

import {
  ContextWorkbenchEntity,
  ContextWorkbenchEntityRef,
} from "../contextWorkbenchEntity";

export function getEntityRefForEntity(
  entity: ContextWorkbenchEntity,
): ContextWorkbenchEntityRef {
  if (entity.type === ContextWorkbenchEntity.Type.MagicRulesFile) {
    return getEntityRefForMagicRulesFile({
      orgId: entity.orgId,
      userId: entity.userId,
      magicRulesFileId: entity.magicRulesFileId,
    });
  } else if (entity.type === ContextWorkbenchEntity.Type.OrgGuideFile) {
    return getEntityRefForOrgGuideFile({
      orgId: entity.orgId,
      orgGuideFileId: entity.orgGuideFileId,
      orgGuideFileVersionId: entity.orgGuideFileVersionId,
    });
  } else {
    guardNever(entity, entity);
    return null as never;
  }
}

function getEntityRefForMagicRulesFile(params: {
  orgId: OrgId;
  userId: UserId | null;
  magicRulesFileId: MagicRulesFileId;
}): ContextWorkbenchEntityRef.MagicRulesFile {
  return {
    type: ContextWorkbenchEntity.Type.MagicRulesFile,
    orgId: params.orgId,
    userId: params.userId,
    magicRulesFileId: params.magicRulesFileId,
  };
}

export function getEntityRefForOrgGuideFile(params: {
  orgId: OrgId;
  orgGuideFileId: OrgGuideFileId;
  orgGuideFileVersionId: OrgGuideFileVersionId;
}): ContextWorkbenchEntityRef.OrgGuideFile {
  return {
    type: ContextWorkbenchEntity.Type.OrgGuideFile,
    orgId: params.orgId,
    orgGuideFileId: params.orgGuideFileId,
    orgGuideFileVersionId: params.orgGuideFileVersionId,
  };
}
